// ProfitMarginCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
// Lazy load shared chart components
const SharedPieChart = React.lazy(() => import("../../Sharedpiechart"));
const TITLE =
  "Kalkulator Persentase Keuntungan - Hitung Margin Laba Kotor, Operasional, dan Bersih";
const DESCRIPTION =
  "Kalkulator persentase keuntungan gratis membantu Anda menghitung margin laba kotor, persentase laba operasional, dan margin laba bersih dengan akurat. Alat ideal untuk pemilik bisnis dan akuntan untuk menganalisis kinerja keuangan dan membuat keputusan penetapan harga yang cerdas.";
const KEYWORDS =
  "kalkulator persentase keuntungan, margin laba, hitung keuntungan, persentase laba kotor, persentase laba operasional, laba bersih, margin laba bersih, kalkulator profitabilitas, rumus keuntungan";
const OG_URL = "https://do-calculate.com/calculator/id/profit-margin-calculator/";
function Calculator() {
  // Calculator Type Selection
  const [calculatorType, setCalculatorType] = useState("gross");
  // Gross Profit Margin State
  const [grossRevenue, setGrossRevenue] = useState("");
  const [cogs, setCogs] = useState("");
  const [grossProfit, setGrossProfit] = useState("");
  const [grossMargin, setGrossMargin] = useState("");
  // Operating Profit Margin State
  const [operatingRevenue, setOperatingRevenue] = useState("");
  const [operatingCogs, setOperatingCogs] = useState("");
  const [operatingExpenses, setOperatingExpenses] = useState("");
  const [operatingProfit, setOperatingProfit] = useState("");
  const [operatingMargin, setOperatingMargin] = useState("");
  // Net Profit Margin State
  const [netRevenue, setNetRevenue] = useState("");
  const [netProfit, setNetProfit] = useState("");
  const [netMargin, setNetMargin] = useState("");
  const [error, setError] = useState("");
  const [showChart, setShowChart] = useState(false);
  const handleGrossProfitCalculate = () => {
    if (!grossRevenue || !cogs) {
      setError("Harap masukkan total pendapatan dan harga pokok penjualan");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(grossRevenue);
    const costOfGoods = parseFloat(cogs);
    if (isNaN(revenue) || isNaN(costOfGoods) || revenue <= 0 || costOfGoods < 0) {
      setError("Harap masukkan nilai yang valid");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    if (costOfGoods > revenue) {
      setError("Harga pokok penjualan tidak boleh lebih besar dari pendapatan");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    const profit = revenue - costOfGoods;
    const margin = (profit / revenue) * 100;
    setGrossProfit(profit.toFixed(2));
    setGrossMargin(margin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleOperatingProfitCalculate = () => {
    if (!operatingRevenue || !operatingCogs || !operatingExpenses) {
      setError("Harap masukkan semua kolom yang diperlukan");
      setOperatingProfit("");
      setOperatingMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(operatingRevenue);
    const costOfGoods = parseFloat(operatingCogs);
    const expenses = parseFloat(operatingExpenses);
    if (isNaN(revenue) || isNaN(costOfGoods) || isNaN(expenses) ||
      revenue <= 0 || costOfGoods < 0 || expenses < 0) {
      setError("Harap masukkan nilai yang valid");
      setOperatingProfit("");
      setOperatingMargin("");
      setShowChart(false);
      return;
    }
    const grossProfit = revenue - costOfGoods;
    const opProfit = grossProfit - expenses;
    const opMargin = (opProfit / revenue) * 100;
    setOperatingProfit(opProfit.toFixed(2));
    setOperatingMargin(opMargin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleNetProfitCalculate = () => {
    if (!netRevenue || !netProfit) {
      setError("Harap masukkan pendapatan bersih dan laba bersih");
      setNetMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(netRevenue);
    const profit = parseFloat(netProfit);
    if (isNaN(revenue) || isNaN(profit) || revenue <= 0) {
      setError("Harap masukkan nilai yang valid");
      setNetMargin("");
      setShowChart(false);
      return;
    }
    const margin = (profit / revenue) * 100;
    setNetMargin(margin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleReset = () => {
    // Reset all states
    setGrossRevenue("");
    setCogs("");
    setGrossProfit("");
    setGrossMargin("");
    setOperatingRevenue("");
    setOperatingCogs("");
    setOperatingExpenses("");
    setOperatingProfit("");
    setOperatingMargin("");
    setNetRevenue("");
    setNetProfit("");
    setNetMargin("");
    setError("");
    setShowChart(false);
  };
  const renderCalculator = () => {
    switch (calculatorType) {
      case "gross":
        return (
          <div >
            <div className="form-group mb-3">
              <label >
                <b>Total Pendapatan (Penjualan Bersih):</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan total pendapatan"
                value={grossRevenue}
                onChange={(e) => setGrossRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>Harga Pokok Penjualan (HPP):</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan harga pokok penjualan"
                value={cogs}
                onChange={(e) => setCogs(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleGrossProfitCalculate}
              >
                Hitung Persentase Laba Kotor
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                Reset
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
            )}
            {!error && grossProfit && (
              <>
                <div className="result-box p-3 mb-3 bg-light border">
                  <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                    <b>Laba Kotor: {grossProfit} Rupiah</b>
                  </h3>
                  <p style={{ fontSize: "16px", color: "#666" }}>
                    Laba = Pendapatan - Harga Pokok Penjualan
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>Persentase Laba Kotor: {grossMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    Dari setiap 100 Rupiah penjualan, Anda mendapatkan {grossMargin} Rupiah laba kotor
                  </p>
                </div>
              </>
            )}
          </div>
        );
      case "operating":
        return (
          <div >
            <div className="form-group mb-3">
              <label >
                <b>Total Pendapatan:</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan total pendapatan"
                value={operatingRevenue}
                onChange={(e) => setOperatingRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>Harga Pokok Penjualan:</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan harga pokok penjualan"
                value={operatingCogs}
                onChange={(e) => setOperatingCogs(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>Biaya Operasional (Administrasi dan Pemasaran):</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan biaya operasional"
                value={operatingExpenses}
                onChange={(e) => setOperatingExpenses(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleOperatingProfitCalculate}
              >
                Hitung Persentase Laba Operasional
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                Reset
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
            )}
            {!error && operatingProfit && (
              <>
                <div className="result-box p-3 mb-3 bg-light border">
                  <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                    <b>Laba Operasional: {operatingProfit} Rupiah</b>
                  </h3>
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    Laba Operasional = Pendapatan - Harga Pokok Penjualan - Biaya Operasional
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>Persentase Laba Operasional: {operatingMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    Efisiensi operasional perusahaan
                  </p>
                </div>
              </>
            )}
          </div>
        );
      case "net":
        return (
          <div >
            <div className="form-group mb-3">
              <label >
                <b>Pendapatan Bersih (Total Penjualan):</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan pendapatan bersih"
                value={netRevenue}
                onChange={(e) => setNetRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>Laba Bersih (Setelah Dikurangi Semua Biaya):</b>
              </label>
              <input
                type="number"
                placeholder="Masukkan laba bersih"
                value={netProfit}
                onChange={(e) => setNetProfit(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleNetProfitCalculate}
              >
                Hitung Margin Laba Bersih
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                Reset
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
            )}
            {!error && netMargin && (
              <>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>Margin Laba Bersih: {netMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    Dari setiap 100 Rupiah penjualan, tersisa {netMargin} Rupiah sebagai laba bersih
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-info text-black">
                  <p style={{ fontSize: "14px", margin: 0 }}>
                    <b>Interpretasi Hasil:</b> {parseFloat(netMargin) >= 15 ? "Profitabilitas sangat baik" : parseFloat(netMargin) >= 10 ? "Profitabilitas baik" : parseFloat(netMargin) >= 5 ? "Profitabilitas sedang" : "Profitabilitas rendah"}
                  </p>
                </div>
              </>
            )}
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            Hitung pendapatan dan keuntungan Anda dengan mudah dan akurat menggunakan alat gratis ini. Cukup masukkan biaya produk atau layanan dan margin keuntungan yang diinginkan, dan kalkulator akan menghasilkan hasil secara instan. Ideal untuk bisnis kecil dan besar, pedagang, dan mahasiswa bisnis.
            Untuk menghitung pendapatan dan keuntungan, kami menggunakan rumus berikut:
          </p>
          <ul>
            <li><b>Pendapatan = Biaya Produk / (1 - (Margin Keuntungan / 100))</b></li>
            <li><b>Keuntungan = Pendapatan - Biaya Produk</b></li>
          </ul>
          <MobileUnderCalAds />
          <div className="border border-light">
            {/* Main Calculator */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Kalkulator Persentase Keuntungan</h2>
                </div>
                <hr />
                <div  className="mb-3">
                  <label >
                    <b>Pilih Jenis Perhitungan Persentase Keuntungan:</b>
                  </label>
                  <select
                    className="form-select"
                    value={calculatorType}
                    onChange={(e) => {
                      setCalculatorType(e.target.value);
                      handleReset();
                    }}
                  >
                    <option value="gross">Persentase Laba Kotor (Gross Profit Margin)</option>
                    <option value="operating">Persentase Laba Operasional (Operating Profit Margin)</option>
                    <option value="net">Margin Laba Bersih (Net Profit Margin)</option>
                  </select>
                </div>
                <hr />
                {renderCalculator()}
              </div>
            </div>
            {showChart && (calculatorType === "gross" && grossMargin) && (
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <React.Suspense
                    fallback={
                      <div className="text-center p-3">
                        Memuat grafik...
                      </div>
                    }
                  >
                    <SharedPieChart
                      firstLabel="Persentase Keuntungan"
                      secondLabel="Persentase Biaya"
                      firstValue={grossMargin}
                      secondValue={(100 - parseFloat(grossMargin)).toFixed(2)}
                      firstColor="#28a745"
                      secondColor="#dc3545"
                      title="Distribusi Keuntungan dan Biaya"
                    />
                  </React.Suspense>
                </div>
              </div>
            )}
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu Kalkulator Persentase Keuntungan?</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Apa itu Kalkulator Persentase Keuntungan?</u>
                  </h2>
                  <p>
                    <b>Kalkulator Persentase Keuntungan</b> adalah alat keuangan cerdas dan gratis yang membantu Anda menghitung berbagai rasio profitabilitas untuk aktivitas bisnis apa pun dengan mudah dan akurat. Kalkulator canggih ini memungkinkan Anda menghitung tiga jenis utama rasio keuntungan:
                  </p>
                  <ul>
                    <li><b>Persentase Laba Kotor (Gross Profit Margin):</b> Mengukur efisiensi perusahaan dalam mengelola biaya produksi langsung</li>
                    <li><b>Persentase Laba Operasional (Operating Profit Margin):</b> Mencerminkan efisiensi operasional sehari-hari perusahaan</li>
                    <li><b>Margin Laba Bersih (Net Profit Margin):</b> Menunjukkan profitabilitas sebenarnya setelah dikurangi semua biaya</li>
                  </ul>
                  <p>
                    Baik Anda pemilik usaha kecil, manajer keuangan, akuntan, atau investor, kalkulator ini memberikan gambaran yang komprehensif dan jelas tentang kinerja keuangan bisnis Anda, membantu Anda membuat keputusan strategis yang terinformasi berdasarkan data yang akurat.
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Cara Menggunakan Kalkulator Persentase Keuntungan:</u>
                  </h2>
                  <p>
                    Penggunaan kalkulator sederhana dan mudah, ikuti langkah-langkah berikut:
                  </p>
                  <ol>
                    <li><b>Pilih Jenis Keuntungan:</b> Tentukan jenis persentase keuntungan yang ingin Anda hitung (kotor, operasional, atau bersih)</li>
                    <li><b>Masukkan Data Keuangan:</b> Masukkan angka yang diperlukan di kolom yang disediakan</li>
                    <li><b>Hitung Hasil:</b> Tekan tombol "Hitung" untuk mendapatkan persentase dan hasil detail</li>
                    <li><b>Analisis Hasil:</b> Tinjau hasil dan interpretasi yang diberikan untuk memahami kinerja bisnis Anda</li>
                    <li><b>Reset:</b> Gunakan tombol "Reset" untuk memulai perhitungan baru</li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Persentase Laba Kotor</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Persentase Laba Kotor (Gross Profit Margin)</u>
                  </h2>
                  <p>
                    <b>Persentase Laba Kotor</b> mengukur seberapa efisien perusahaan dalam memproduksi atau membeli barang dibandingkan dengan pendapatan penjualan. Rasio ini mencerminkan keuntungan yang tersisa setelah dikurangi biaya produksi langsung.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>Rumus:</b></p>
                    <p>Laba Kotor = Penjualan Bersih - Harga Pokok Penjualan</p>
                    <p>Persentase Laba Kotor = (Laba Kotor ÷ Penjualan Bersih) × 100%</p>
                  </div>
                  <p><b>Contoh Praktis:</b></p>
                  <ul>
                    <li>Penjualan Bersih = 100.000 Rupiah</li>
                    <li>Harga Pokok Penjualan = 60.000 Rupiah</li>
                    <li>Laba Kotor = 100.000 - 60.000 = 40.000 Rupiah</li>
                    <li>Persentase Laba Kotor = (40.000 ÷ 100.000) × 100 = 40%</li>
                  </ul>
                  <p><b>Interpretasi:</b> Dari setiap 100 Rupiah penjualan, perusahaan mendapatkan 40 Rupiah laba kotor sebelum dikurangi biaya operasional.</p>
                  <p><b>Apa yang termasuk dalam Harga Pokok Penjualan:</b></p>
                  <ul>
                    <li>Biaya bahan baku</li>
                    <li>Upah tenaga kerja langsung</li>
                    <li>Biaya manufaktur langsung</li>
                    <li>Biaya pengiriman dan impor</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Persentase Laba Operasional</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Persentase Laba Operasional (Operating Profit Margin)</u>
                  </h2>
                  <p>
                    <b>Persentase Laba Operasional</b> mencerminkan keuntungan yang dihasilkan dari operasi inti perusahaan, setelah dikurangi semua biaya operasional seperti gaji administrasi, pemasaran, dan sewa.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>Rumus:</b></p>
                    <p>Laba Operasional = Total Pendapatan - Harga Pokok Penjualan - Biaya Operasional</p>
                    <p>Persentase Laba Operasional = (Laba Operasional ÷ Penjualan Bersih) × 100%</p>
                  </div>
                  <p><b>Contoh Praktis:</b></p>
                  <ul>
                    <li>Penjualan Bersih = 100.000 Rupiah</li>
                    <li>Harga Pokok Penjualan = 60.000 Rupiah</li>
                    <li>Biaya Operasional = 20.000 Rupiah</li>
                    <li>Laba Kotor = 100.000 - 60.000 = 40.000 Rupiah</li>
                    <li>Laba Operasional = 40.000 - 20.000 = 20.000 Rupiah</li>
                    <li>Persentase Laba Operasional = (20.000 ÷ 100.000) × 100 = 20%</li>
                  </ul>
                  <p><b>Biaya Operasional meliputi:</b></p>
                  <ul>
                    <li>Gaji administrasi</li>
                    <li>Biaya pemasaran dan iklan</li>
                    <li>Sewa dan utilitas</li>
                    <li>Biaya penelitian dan pengembangan</li>
                    <li>Biaya pemeliharaan</li>
                    <li>Penyusutan dan amortisasi</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Margin Laba Bersih</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Margin Laba Bersih (Net Profit Margin)</u>
                  </h2>
                  <p>
                    <b>Margin Laba Bersih</b> adalah metrik yang paling komprehensif dan penting, karena menunjukkan persentase dari pendapatan yang tersisa sebagai laba bersih setelah dikurangi semua biaya tanpa kecuali.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>Rumus:</b></p>
                    <p>Laba Bersih = Pendapatan - Harga Pokok Penjualan - Biaya Operasional - Pajak - Biaya Lainnya</p>
                    <p>Margin Laba Bersih = (Laba Bersih ÷ Penjualan Bersih) × 100%</p>
                  </div>
                  <p><b>Contoh Praktis Lengkap:</b></p>
                  <ul>
                    <li>Total Pendapatan = 100.000 Rupiah</li>
                    <li>Harga Pokok Penjualan = 60.000 Rupiah</li>
                    <li>Laba Kotor = 40.000 Rupiah (rasio 40%)</li>
                    <li>Biaya Operasional = 20.000 Rupiah</li>
                    <li>Laba Operasional = 20.000 Rupiah (rasio 20%)</li>
                    <li>Pajak = 5.000 Rupiah</li>
                    <li>Laba Bersih = 15.000 Rupiah</li>
                    <li>Margin Laba Bersih = (15.000 ÷ 100.000) × 100 = 15%</li>
                  </ul>
                  <p><b>Kriteria Evaluasi Margin Laba Bersih:</b></p>
                  <ul>
                    <li><b>Sangat Baik:</b> 15% ke atas - Perusahaan dengan profitabilitas tinggi</li>
                    <li><b>Baik:</b> 10-15% - Kinerja keuangan baik</li>
                    <li><b>Sedang:</b> 5-10% - Profitabilitas wajar</li>
                    <li><b>Rendah:</b> Kurang dari 5% - Perlu peningkatan</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Penggunaan Kalkulator Persentase Keuntungan</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>Kasus Penggunaan Kalkulator Persentase Keuntungan:</u>
                  </h2>
                  <ol>
                    <li>
                      <b>Menentukan Profitabilitas Produk dan Layanan:</b>
                      <p>Mengukur laba kotor untuk setiap produk atau layanan untuk mengetahui produk mana yang paling menguntungkan dan layak untuk difokuskan.</p>
                    </li>
                    <li>
                      <b>Membuat Keputusan Penetapan Harga yang Cerdas:</b>
                      <p>Menentukan harga yang tepat untuk produk berdasarkan target persentase keuntungan, memastikan pencapaian tujuan keuangan.</p>
                    </li>
                    <li>
                      <b>Menganalisis Kinerja Operasional:</b>
                      <p>Mengevaluasi efisiensi perusahaan dalam mengelola biaya operasional sehari-hari dan menemukan peluang pengurangan biaya.</p>
                    </li>
                    <li>
                      <b>Mengevaluasi Profitabilitas Akhir:</b>
                      <p>Memahami keuntungan sebenarnya yang tersisa setelah dikurangi semua biaya, yang merupakan indikator terpenting bagi investor.</p>
                    </li>
                    <li>
                      <b>Membandingkan Kinerja dengan Pesaing:</b>
                      <p>Membandingkan rasio keuntungan Anda dengan rata-rata industri untuk menentukan posisi kompetitif Anda.</p>
                    </li>
                    <li>
                      <b>Analisis Kelayakan Finansial Proyek:</b>
                      <p>Menguji berbagai skenario sebelum meluncurkan produk baru atau memasuki pasar baru.</p>
                    </li>
                    <li>
                      <b>Menyiapkan Laporan Keuangan:</b>
                      <p>Menyediakan data akurat tentang rasio profitabilitas untuk dimasukkan dalam laporan bulanan dan tahunan.</p>
                    </li>
                    <li>
                      <b>Menarik Investasi:</b>
                      <p>Menampilkan rasio keuntungan yang kuat kepada calon investor untuk membuktikan kelayakan proyek.</p>
                    </li>
                    <li>
                      <b>Perencanaan Strategis:</b>
                      <p>Menetapkan target keuangan yang realistis dan memantau kemajuan menuju pencapaiannya.</p>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Pertanyaan Umum</div>
              <div className="info-section-body">
                <div>
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Apa perbedaan antara margin keuntungan dan persentase keuntungan?</b>
                  </h3>
                  <p>
                    <b>Margin Keuntungan</b> dan <b>Persentase Keuntungan</b> adalah dua istilah yang sinonim yang merujuk pada konsep yang sama - yaitu persentase keuntungan dari penjualan. Keduanya dihitung dengan cara yang sama dan dinyatakan sebagai persentase.
                  </p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Bagaimana cara menghitung persentase keuntungan dari harga pokok?</b>
                  </h3>
                  <p>
                    Untuk menghitung persentase keuntungan dari harga pokok (bukan dari harga jual):
                  </p>
                  <p>Persentase Keuntungan dari Harga Pokok = [(Harga Jual - Harga Pokok) ÷ Harga Pokok] × 100</p>
                  <p><b>Contoh:</b> Harga pokok produk 100 Rupiah, harga jual 150 Rupiah</p>
                  <p>Persentase Keuntungan dari Harga Pokok = [(150 - 100) ÷ 100] × 100 = 50%</p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Berapa persentase keuntungan yang baik?</b>
                  </h3>
                  <p>
                    Persentase keuntungan yang baik bervariasi tergantung industri dan sektor:
                  </p>
                  <ul>
                    <li><b>Ritel:</b> 2-5% margin laba bersih</li>
                    <li><b>Grosir:</b> 5-15% margin laba bersih</li>
                    <li><b>Restoran dan Kafe:</b> 3-8% margin laba bersih</li>
                    <li><b>Perangkat Lunak dan Teknologi:</b> 15-25% margin laba bersih</li>
                    <li><b>Jasa Konsultasi:</b> 10-20% margin laba bersih</li>
                    <li><b>Industri Manufaktur:</b> 5-10% margin laba bersih</li>
                  </ul>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Bagaimana cara menghitung harga jual jika saya tahu harga pokok dan persentase keuntungan yang diinginkan?</b>
                  </h3>
                  <p>
                    Untuk menghitung harga jual berdasarkan target persentase keuntungan:
                  </p>
                  <p>Harga Jual = Harga Pokok ÷ (1 - Target Persentase Keuntungan)</p>
                  <p><b>Contoh:</b> Harga pokok produk 100 Rupiah, ingin mencapai margin keuntungan 30%</p>
                  <p>Harga Jual = 100 ÷ (1 - 0.30) = 100 ÷ 0.70 = 142.86 Rupiah</p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Mengapa margin laba bersih lebih penting daripada laba kotor?</b>
                  </h3>
                  <p>
                    <b>Margin Laba Bersih</b> memberikan gambaran lengkap tentang profitabilitas perusahaan yang sebenarnya karena memperhitungkan semua biaya termasuk pajak. Sementara <b>Laba Kotor</b> hanya berfokus pada biaya produksi langsung.
                  </p>
                  <p>
                    Perusahaan mungkin memiliki laba kotor yang tinggi, tetapi jika biaya operasional sangat tinggi, bisa berakhir dengan margin laba bersih yang rendah atau bahkan kerugian.
                  </p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>Bagaimana cara meningkatkan persentase keuntungan dalam bisnis saya?</b>
                  </h3>
                  <p>Untuk meningkatkan persentase keuntungan, Anda dapat:</p>
                  <ol>
                    <li><b>Menaikkan harga:</b> Jika nilai yang diberikan dapat dibenarkan</li>
                    <li><b>Mengurangi harga pokok penjualan:</b> Negosiasi dengan pemasok, pembelian grosir</li>
                    <li><b>Mengurangi biaya operasional:</b> Otomatisasi proses, peningkatan efisiensi</li>
                    <li><b>Meningkatkan volume penjualan:</b> Pemasaran efektif, perluasan basis pelanggan</li>
                    <li><b>Fokus pada produk yang paling menguntungkan:</b> Analisis profitabilitas setiap produk</li>
                    <li><b>Meningkatkan manajemen inventaris:</b> Mengurangi pemborosan dan kerusakan</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;